import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";

export class RelatedObject extends DetailViewContentElement {
  related_object_id: string;
  related_object: {[key: string]: any};
  list_view_id: string;
  list_view: {id: string, title: string};
  record_display_limit: number;
  inverse: boolean;

  constructor() {
    super();
    this.defineProperty('related_object_id', null);
    this.defineProperty('record_display_limit', null);
    this.defineProperty('list_view_id', null);
    this.defineProperty('inverse', null)
  }

  except = ["list_view", "related_object"];

  get defaultLabel(): string {
    return "Related Object(s)"
  }
}